import apiAthleteScholarship from '@/api/athlete-scholarship'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0
}

export const mutationTypes = {
  getAthleteScholarshipStart:
    '[athlete scholarship] Get athlete scholarship start',
  getAthleteScholarshipSuccess:
    '[athlete scholarship] Get athlete scholarship success',
  getAthleteScholarshipFailure:
    '[athlete scholarship] Get athlete scholarship failure'
}

export const actionTypes = {
  getAthleteScholarship: '[athlete scholarship] Get athlete by id result'
}

const mutations = {
  [mutationTypes.getAthleteScholarshipStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getAthleteScholarshipSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getAthleteScholarshipFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getAthleteScholarship](context, {params}) {
    context.commit(mutationTypes.getAthleteScholarshipStart)
    return new Promise(resolve => {
      apiAthleteScholarship
        .getAthleteScholarshipParams(params)
        .then(response => {
          const result = response.data ? response.data : response
          context.commit(mutationTypes.getAthleteScholarshipSuccess, response)
          resolve(result)
        })
        .catch(error => {
          context.commit(mutationTypes.getAthleteScholarshipFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
